/* eslint-disable sort-keys */

import { insertIf } from '@mighty-justice/utils';

function getFieldSetsPlaintiff (canSeeSpanishSpeaking: boolean) {
  return [
    [
      {
        className: 'fs-mask',
        editProps: {
          validationErrors: { isValidPlaintiffName: 'First name cannot be greater than 30 characters' },
          validations: { isValidPlaintiffName: true },
        },
        field: 'first_name',
        required: true,
        writeOnly: true,
      },
      {
        className: 'fs-mask',
        editProps: {
          validationErrors: { isValidPlaintiffName: 'Last name cannot be greater than 30 characters' },
          validations: { isValidPlaintiffName: true },
        },
        field: 'last_name',
        required: true,
        writeOnly: true,
      },
    ],
    [
      { field: 'phone_number', label: 'Phone #', type: 'phone' },
      { field: 'email', type: 'email' },
      { field: 'birthdate', type: 'date', className: 'fs-mask' },
      { field: 'sex', type: 'optionSelect', optionType: 'sexOptions', optionKey: 'value', nullify: false },
      { field: 'social_security_number', label: 'SSN', type: 'ssn', className: 'fs-mask' },
    ],
    [
      { field: 'address', type: 'address' },
    ],
    ...insertIf(canSeeSpanishSpeaking, [
      { field: 'is_spanish_speaking', type: 'requiredBoolean', label: 'Spanish Speaking?', required: true },
    ]),
  ];
}

export default getFieldSetsPlaintiff;
